const addToLookupTable = ({
  id,
  byId,
  payload
}) => {
  const newById = { ...byId, [id]: payload };
  return {
    newAllIDs: Object.keys(newById),
    newById
  };
};
const arrayInsertAtIndex = ({
  array,
  item,
  index
}) => {
  if (!Array.isArray(array) || !Number.isFinite(index)) {
    return [];
  }
  return [...array.slice(0, index), item, ...array.slice(index)];
};
const createBinaryExpression = (operatorDef, left, right) => {
  if (!(operatorDef == null ? void 0 : operatorDef.operator))
    throw new Error("malformed operator");
  if ((operatorDef == null ? void 0 : operatorDef.expressionType) !== "binary" && (operatorDef == null ? void 0 : operatorDef.expressionType) !== "null")
    throw new Error(
      `operator of expressionType '${operatorDef.expressionType}' is incompatible with binary expressions`
    );
  if (!left)
    throw new Error(`binary expression requires non-empty left expression`);
  if (!right)
    throw new Error(`binary expression requires non-empty left expression`);
  return {
    expressionType: "binary",
    left,
    operator: operatorDef.operator,
    right
  };
};
var ExpressionType = /* @__PURE__ */ ((ExpressionType2) => {
  ExpressionType2["NULL"] = "null";
  ExpressionType2["BINARY"] = "binary";
  ExpressionType2["VARIADIC"] = "variadic";
  ExpressionType2["UNARY"] = "unary";
  return ExpressionType2;
})(ExpressionType || {});
var HQLOperator = /* @__PURE__ */ ((HQLOperator2) => {
  HQLOperator2["AND"] = "AND";
  HQLOperator2["CONTAINS"] = "CONTAINS";
  HQLOperator2["DOES_NOT_CONTAIN"] = "DOES NOT CONTAIN";
  HQLOperator2["DOES_NOT_EQUAL"] = "DOES NOT EQUAL";
  HQLOperator2["EQUALS"] = "EQUALS";
  HQLOperator2["GREATER_THAN"] = "GREATER THAN";
  HQLOperator2["NEVER_OCCURRED"] = "NEVER OCCURRED";
  HQLOperator2["NULL"] = "NULL";
  HQLOperator2["OCCURED_AFTER"] = "OCCURED AFTER";
  HQLOperator2["OCCURRED_AFTER_RELATIVE"] = "OCCURRED AFTER RELATIVE";
  HQLOperator2["OCCURRED_BEFORE_RELATIVE"] = "OCCURRED BEFORE RELATIVE";
  HQLOperator2["OCCURRED_BEFORE"] = "OCCURRED BEFORE";
  HQLOperator2["OCCURRED_IN_YEAR"] = "OCCURRED IN year";
  HQLOperator2["OCCURRED_ON_DAY"] = "OCCURRED ON DAY";
  HQLOperator2["OCCURRED_ON"] = "OCCURRED ON";
  HQLOperator2["OCCURRED"] = "OCCURRED";
  HQLOperator2["OR"] = "OR";
  HQLOperator2["STARTS_WITH"] = "STARTS WITH";
  return HQLOperator2;
})(HQLOperator || {});
const operatorDefinitions = Object.freeze({
  and: {
    expressionType: ExpressionType.VARIADIC,
    label: "and",
    operator: HQLOperator.AND
  },
  contains: {
    expressionType: ExpressionType.BINARY,
    label: "contains",
    operator: HQLOperator.CONTAINS
  },
  doesNotContain: {
    expressionType: ExpressionType.BINARY,
    label: "does not contain",
    operator: HQLOperator.DOES_NOT_CONTAIN
  },
  doesNotEqual: {
    expressionType: ExpressionType.BINARY,
    label: "does not equal",
    operator: HQLOperator.DOES_NOT_EQUAL
  },
  equals: {
    expressionType: ExpressionType.BINARY,
    label: "is equal to",
    operator: HQLOperator.EQUALS
  },
  greaterThan: {
    expressionType: ExpressionType.BINARY,
    label: "is greater than",
    operator: HQLOperator.GREATER_THAN
  },
  isAfter: {
    expressionType: ExpressionType.BINARY,
    label: "is after",
    operator: HQLOperator.OCCURED_AFTER
  },
  isAfterDay: {
    expressionType: ExpressionType.BINARY,
    label: "is after day",
    operator: HQLOperator.OCCURRED_AFTER_RELATIVE
  },
  isBefore: {
    expressionType: ExpressionType.BINARY,
    label: "is before",
    operator: HQLOperator.OCCURRED_BEFORE
  },
  isBeforeDay: {
    expressionType: ExpressionType.BINARY,
    label: "is before day",
    operator: HQLOperator.OCCURRED_BEFORE_RELATIVE
  },
  isInYear: {
    expressionType: ExpressionType.BINARY,
    label: "is in year",
    operator: HQLOperator.OCCURRED_IN_YEAR
  },
  isOn: {
    expressionType: ExpressionType.BINARY,
    label: "is on",
    operator: HQLOperator.OCCURRED_ON
  },
  isOnDay: {
    expressionType: ExpressionType.BINARY,
    label: "is on the day",
    operator: HQLOperator.OCCURRED_ON_DAY
  },
  neverOccurred: {
    expressionType: ExpressionType.UNARY,
    label: "never occurred",
    operator: HQLOperator.NEVER_OCCURRED
  },
  null: {
    expressionType: ExpressionType.NULL,
    label: "null",
    operator: HQLOperator.NULL
  },
  occurred: {
    expressionType: ExpressionType.UNARY,
    label: "occurred",
    operator: HQLOperator.OCCURRED
  },
  or: {
    expressionType: ExpressionType.VARIADIC,
    label: "or",
    operator: HQLOperator.OR
  },
  startsWith: {
    expressionType: ExpressionType.BINARY,
    label: "starts with",
    operator: HQLOperator.STARTS_WITH
  }
});
const operatorDefinitionsList = Object.values(operatorDefinitions);
const getOperatorDefinitionByOperator = (operator) => {
  return operatorDefinitionsList.find((opDef) => opDef.operator === operator) || null;
};
const mapOperator = (array) => {
  return array.map((op) => operatorDefinitions[op]).filter((o) => o);
};
const booleanOperationList = mapOperator(["equals"]);
const campaignOperationList = mapOperator([
  "occurred",
  "neverOccurred",
  "equals",
  "doesNotEqual"
]);
const dateOperationList = mapOperator([
  "isAfterDay",
  "isBeforeDay",
  "isOn",
  "isInYear"
]);
const numberOperationList = mapOperator([
  "equals",
  "greaterThan",
  "lessThan",
  "isNotEqualTo"
]);
const relativeDateOperationList = mapOperator([
  "isAfter",
  "isBefore",
  "isOnDay"
]);
const stringOperationList = mapOperator([
  "contains",
  "doesNotContain",
  "doesNotEqual",
  "equals",
  "startsWith"
]);
const operatorDefinitionsByType = {
  bool: booleanOperationList,
  campaign: campaignOperationList,
  date: [...dateOperationList, ...relativeDateOperationList],
  number: numberOperationList,
  relativeDate: relativeDateOperationList,
  string: stringOperationList
};
const createNullExpression = () => ({
  operator: operatorDefinitions.null.operator,
  type: "null"
});
const createUnaryExpression = (operatorDef, operand) => {
  if (!(operatorDef == null ? void 0 : operatorDef.operator))
    throw new Error("malformed operator");
  if ((operatorDef == null ? void 0 : operatorDef.expressionType) !== "unary" && (operatorDef == null ? void 0 : operatorDef.expressionType) !== "null")
    throw new Error(
      `operator of expressionType '${operatorDef.expressionType}' is incompatible with unary expressions`
    );
  if (!operand)
    throw new Error(`unary expression requires non-empty operand`);
  return {
    expressionType: "unary",
    operands: [operand],
    operator: operatorDef.operator
  };
};
const createVariadicExpression = (operatorDef, ...operands) => {
  if (!(operatorDef == null ? void 0 : operatorDef.operator))
    throw new Error("malformed operator");
  if ((operatorDef == null ? void 0 : operatorDef.expressionType) !== "variadic" && (operatorDef == null ? void 0 : operatorDef.expressionType) !== "null")
    throw new Error(
      `operator of expressionType '${operatorDef.expressionType}' is incompatible with variadic expressions`
    );
  return {
    expressionType: "variadic",
    operands: operands || [],
    operator: operatorDef.operator
  };
};
const parseBuilderQuery = (originalBuilderQuery) => {
  var _a, _b;
  if (!originalBuilderQuery || !Array.isArray(originalBuilderQuery == null ? void 0 : originalBuilderQuery.operands)) {
    return originalBuilderQuery;
  }
  const builderQuery = JSON.parse(JSON.stringify(originalBuilderQuery));
  const expandedTree = [];
  for (let i = 0, len = builderQuery.operands.length; i < len; i += 1) {
    const originalRow = builderQuery.operands[i];
    let newRow = { ...originalRow };
    if (originalRow.expressionType === "variadic" && ((_a = originalRow.operands[0]) == null ? void 0 : _a.expressionType) === "binary") {
      const rows = [...originalRow.operands];
      newRow = { ...rows[0] };
      if (rows.length > 1) {
        newRow.right = createVariadicExpression(
          operatorDefinitions.or,
          ...rows.map((r) => r.right)
        );
      }
    }
    expandedTree.push(newRow);
  }
  const newTree = [];
  for (let i = 0, len = expandedTree.length; i < len; i += 1) {
    const row = { ...expandedTree[i] };
    switch (row.expressionType) {
      case "binary":
        row.left = {
          ...row.left,
          fieldTarget: row.left.source,
          source: row.left.sourceName
        };
        delete row.left.sourceName;
        break;
      case "unary":
        row.operands[0] = {
          ...row.operands[0],
          fieldTarget: row.operands[0].source,
          source: row.operands[0].sourceName
        };
        delete row.operands[0].sourceName;
        break;
    }
    if (row.expressionType === "binary" && ((_b = row.right) == null ? void 0 : _b.type) === "relativeDate") {
      const currentDateValue = row.right.value;
      const dateDirection = currentDateValue > 0 ? "from now" : "ago";
      row.right = {
        ...row.right,
        direction: dateDirection,
        value: Math.abs(currentDateValue).toString()
      };
    }
    newTree.push(row);
  }
  return { ...originalBuilderQuery, operands: [...newTree] };
};
const sanitizeBuilderQuery = (originalBuilderQuery) => {
  var _a, _b, _c, _d, _e;
  if (!originalBuilderQuery || !Array.isArray(originalBuilderQuery == null ? void 0 : originalBuilderQuery.operands))
    return originalBuilderQuery;
  const builderQuery = JSON.parse(JSON.stringify(originalBuilderQuery));
  let newTree = [];
  for (let i = 0, len = builderQuery.operands.length; i < len; i += 1) {
    const row = { ...builderQuery.operands[i] };
    switch (row.expressionType) {
      case "binary":
        if (((_a = row == null ? void 0 : row.left) == null ? void 0 : _a.fieldTarget) === "phoneType" || ((_b = row == null ? void 0 : row.left) == null ? void 0 : _b.source) === "phoneType") {
          row.left = {
            ...row.left,
            source: "phoneType",
            sourceName: "phoneType"
          };
        } else if (((_c = row == null ? void 0 : row.left) == null ? void 0 : _c.fieldTarget) === "campaign" || ((_d = row == null ? void 0 : row.left) == null ? void 0 : _d.source) === "campaign") {
          row.left = {
            ...row.left,
            source: "campaign",
            sourceName: "campaign"
          };
        } else {
          row.left = {
            ...row.left,
            source: row.left.fieldTarget,
            sourceName: row.left.source
          };
        }
        delete row.left.fieldTarget;
        break;
      case "unary":
        row.operands[0] = row.operands[0].fieldTarget === "campaign" || row.operands[0].source === "campaign" ? { ...row.operands[0], source: "campaign", sourceName: "campaign" } : {
          ...row.operands[0],
          source: row.operands[0].fieldTarget,
          sourceName: row.operands[0].source
        };
        delete row.operands[0].fieldTarget;
        break;
    }
    newTree = [...newTree, row];
  }
  for (let i = 0, len = newTree.length; i < len; i += 1) {
    const originalRow = newTree[i];
    let row = { ...originalRow };
    if (originalRow.expressionType === "binary" && (originalRow == null ? void 0 : originalRow.right.type) === "relativeDate") {
      const currentDateValue = Math.abs(parseInt(row.right.value, 10));
      if (!Number.isNaN(currentDateValue)) {
        row.right = {
          ...row.right,
          value: row.right.direction === "ago" ? (currentDateValue * -1).toString() : currentDateValue.toString()
        };
        delete row.right.direction;
      }
    }
    if (originalRow.expressionType === "binary" && ((_e = originalRow.right) == null ? void 0 : _e.expressionType) === "variadic") {
      const multipleRows = originalRow.right.operands.map((op) => ({
        ...originalRow,
        right: op
      }));
      row = createVariadicExpression(operatorDefinitions.or, ...multipleRows);
    }
    newTree[i] = row;
  }
  return { ...builderQuery, operands: newTree };
};
const createConstantValue = (value) => {
  if (value === null || value === void 0)
    throw new Error(
      `value of type ${typeof value} is incompatible with constant expressions`
    );
  return {
    type: "constant",
    value
  };
};
const createReferenceValue = (sourceField) => {
  if (!(sourceField == null ? void 0 : sourceField.type))
    throw new Error(`sourceField must contain a 'type' property`);
  if (!(sourceField == null ? void 0 : sourceField.fieldTarget))
    throw new Error(`sourceField must contain a 'fieldTarget' property`);
  return {
    fieldTarget: sourceField == null ? void 0 : sourceField.fieldTarget,
    fieldType: sourceField == null ? void 0 : sourceField.type,
    source: sourceField == null ? void 0 : sourceField.source,
    type: "reference",
    value: sourceField == null ? void 0 : sourceField.fieldName
  };
};
const relativeDatePeriods = ["days", "months", "years"];
const relativeDateDirections = ["ago", "from now"];
const createRelativeDateValue = (value, period, direction) => {
  if (value != null && Number.isNaN(parseInt(value, 10)))
    throw new Error(
      `RelativeDateExpression 'value' parameter must be parseable as an integer, received ${value}`
    );
  if (period != null && (typeof period !== "string" || !relativeDatePeriods.includes(period)))
    throw new Error(
      `RelativeDateExpression 'periods' parameter must be a valid RelativeDatePeriod, received ${period}`
    );
  if (direction != null && (typeof direction !== "string" || !relativeDateDirections.includes(direction)))
    throw new Error(
      `RelativeDateExpression 'direction' parameter must be a valid RelativeDateDirection, received ${direction}`
    );
  return {
    direction,
    period,
    type: "relativeDate",
    value
  };
};
const boardIdFromColumnId = (id) => {
  if (id.indexOf(":") === -1) {
    return null;
  }
  const split0 = id.split(":")[0];
  if (split0.trim().length === 0) {
    return null;
  }
  return split0;
};
const buildHQLQueryFromFilters = (filters) => {
  if (!Array.isArray(filters) || !filters.length) {
    return "";
  }
  let qs = "";
  filters.forEach((filter, index) => {
    let newFilter = "";
    switch (filter) {
      case "new":
        newFilter = "campaign NEVER OCCURRED";
        break;
      case "replied":
        newFilter = 'campaign:"Status" EQUALS "replied"';
        break;
      case "no reply":
        newFilter = 'campaign:"Status" DOES NOT EQUAL "replied" AND campaign OCCURRED';
        break;
      case "mobile":
        newFilter = 'phoneType EQUALS "mobile"';
        break;
      case "landline":
        newFilter = 'phoneType EQUALS "landline"';
        break;
    }
    qs = `${qs}${index !== 0 ? " AND " : ""}${newFilter}`;
  });
  return qs;
};
const injectTermIntoSimpleSearch = (query) => {
  return `contact CONTAINS "${query}" OR details CONTAINS "${query}"`;
};
const buildHQLQueryFromString = (query) => {
  if (typeof query !== "string" || !query.length) {
    return "";
  }
  return injectTermIntoSimpleSearch(query.trim());
};
const buildSimpleSearchQuery = (query, filters = []) => {
  const contact = buildHQLQueryFromString(query);
  const filter = buildHQLQueryFromFilters(filters);
  const delimeter = filter.length && contact.length ? " AND " : "";
  return `${delimeter !== "" ? `(${contact})` : contact}${delimeter}${filter}`;
};
const calculateCurrentPage = (offset, itemsPerPage) => {
  if (!Number.isFinite(offset) || !Number.isFinite(itemsPerPage) || offset < 1 || itemsPerPage < 1) {
    return 1;
  }
  return Math.ceil((offset + 1) / itemsPerPage);
};
const calculateTotalPages = (itemCountPerPage, totalItemCount) => {
  if (!itemCountPerPage || !totalItemCount || !Number.isFinite(itemCountPerPage) || !Number.isFinite(totalItemCount) || totalItemCount < 1 || itemCountPerPage < 1) {
    return 0;
  }
  return Math.ceil(totalItemCount / itemCountPerPage);
};
var HTTPMethod = /* @__PURE__ */ ((HTTPMethod2) => {
  HTTPMethod2["CONNECT"] = "CONNECT";
  HTTPMethod2["DELETE"] = "DELETE";
  HTTPMethod2["GET"] = "GET";
  HTTPMethod2["HEAD"] = "HEAD";
  HTTPMethod2["OPTIONS"] = "OPTIONS";
  HTTPMethod2["PATCH"] = "PATCH";
  HTTPMethod2["POST"] = "POST";
  HTTPMethod2["PUT"] = "PUT";
  HTTPMethod2["TRACE"] = "TRACE";
  return HTTPMethod2;
})(HTTPMethod || {});
const buildFilterQueryParams = (entry) => {
  const [key, filterObj] = entry;
  return Object.entries(filterObj).filter(([, value]) => ["", null, void 0].every((e) => e !== value)).map(([k, v]) => `${key}[${k}]=${v}`);
};
const buildSortQueryParams = (entry) => {
  const [key, sortObj] = entry;
  return Object.entries(sortObj).map(([, v]) => `${key}[]=${v}`);
};
const generateQueryParams = (obj) => {
  const queryArr = Object.entries(obj).filter(([, value]) => ["", null, void 0].every((e) => e !== value)).map((entry) => {
    const [key] = entry;
    switch (key) {
      case "filter":
        return buildFilterQueryParams(entry);
      case "sort":
        return buildSortQueryParams(entry);
      default:
        return entry.join("=");
    }
  }).flat();
  if (queryArr.length === 0) {
    return "";
  }
  return encodeURI(`?${queryArr.join("&")}`);
};
const fetchRequest = async ({
  data = {},
  domain,
  endpoint,
  headers,
  method,
  query = {},
  signal = null
}) => {
  const requestURL = domain ? `https://${domain}.usehatchapp.com/api${endpoint}${generateQueryParams(
    query
  )}` : `/api${endpoint}${generateQueryParams(query)}`;
  const requestMethod = method || HTTPMethod.GET;
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    method: requestMethod,
    signal
  };
  if (requestMethod !== HTTPMethod.GET) {
    if (typeof data === "object") {
      requestOptions.body = JSON.stringify(data);
    } else {
      requestOptions.body = data;
    }
  }
  return fetch(requestURL, requestOptions).then(async (response) => {
    var _a;
    const { status: statusCode } = response;
    const contentType = response.headers.get("content-type");
    const responseData = contentType && contentType.indexOf("application/json") !== -1 ? await response.json() : null;
    if (statusCode >= 500) {
      return {
        body: {
          data: null
        },
        error: {
          message: "Internal server error",
          response: (_a = responseData == null ? void 0 : responseData.errors) != null ? _a : "Internal server error"
        },
        statusCode
      };
    }
    if (responseData) {
      if (typeof responseData === "object") {
        if (statusCode >= 400) {
          return {
            body: {
              data: null
            },
            error: {
              message: Array.isArray(responseData.errors) ? responseData.errors[0] : JSON.stringify(responseData),
              response: responseData
            },
            statusCode
          };
        }
        if (responseData) {
          if ("data" in responseData) {
            return { body: { ...responseData }, statusCode };
          }
          if (!Array.isArray(responseData)) {
            return { body: { data: { ...responseData } }, statusCode };
          }
        }
      }
      return { body: { data: responseData }, statusCode };
    }
    return { body: { data: responseData }, statusCode };
  }).then((parsedResponse) => {
    return { statusCode: 200, ...parsedResponse };
  }).catch((err) => {
    return {
      body: {
        data: null
      },
      error: {
        message: err.message,
        response: err.response
      },
      statusCode: err.status
    };
  });
};
const fileNameFromURL = (url) => {
  return url.replace(/^.*[\\/]/, "");
};
const formatPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber !== "string")
    return phoneNumber;
  const cleaned = phoneNumber.replace(/\D/g, "");
  const cleanedWithoutCountryCode = cleaned.charAt(0) === "1" ? cleaned.slice(1) : cleaned;
  const match = cleanedWithoutCountryCode.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};
const formatCustomerName = ({
  defaultCustomerName = "Customer",
  firstName = "",
  lastName = "",
  phoneNumber,
  email
} = {}) => {
  if (firstName || lastName) {
    return `${firstName === null ? "" : firstName} ${lastName === null ? "" : lastName}`.trim();
  }
  if (phoneNumber) {
    return formatPhoneNumber(phoneNumber);
  }
  return email || defaultCustomerName;
};
const formatFileSize = (size) => {
  const units = ["B", "kB", "MB", "GB", "TB"];
  if (size <= 0) {
    return `0 ${units[0]}`;
  }
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / 1024 ** i).toFixed(0)} ${units[i]}`;
};
const formatPercentage = (number) => {
  return number.toLocaleString(void 0, {
    maximumFractionDigits: 2,
    style: "percent"
  });
};
const generateColor = (id = "00000001", colorsArr = ["#fff"]) => {
  try {
    if (typeof id !== "string" || !Array.isArray(colorsArr) || !colorsArr.length) {
      return {
        color: "#fff",
        isDark: false
      };
    }
    const summedId = id.split("").reduce((acc, cur) => {
      return acc + parseInt(cur, 10) || 0;
    }, 0);
    const hex = colorsArr[summedId % colorsArr.length];
    const rgb = hex.replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`
    ).substring(1).match(/.{2}/g).map((x) => parseInt(x, 16));
    const isDark = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1e3 < 141;
    return {
      color: hex,
      isDark
    };
  } catch (err) {
    return {
      color: colorsArr[0],
      isDark: false
    };
  }
};
const getFileExtension = (fileName) => {
  return fileName.substr(fileName.lastIndexOf(".") + 1);
};
const removeFromLookupTable = ({
  id,
  byId
}) => {
  const { [id]: idToRemove, ...newById } = byId;
  return {
    newAllIDs: Object.keys(newById),
    newById
  };
};
const validateEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};
const createAPIKey = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/api_keys`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const readAPIKeys = async ({
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/api_keys`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const revokeAPIKey = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  apiKeyId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/api_keys/${apiKeyId}/revoke`,
    headers,
    method: HTTPMethod.DELETE,
    query,
    signal
  });
};
const deleteAudience = async ({
  data,
  domain,
  headers,
  query,
  audienceId,
  locationId,
  boardId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/audiences/${audienceId}`,
    headers,
    method: HTTPMethod.DELETE,
    query,
    signal
  });
};
const getContactsTotalCount = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/contacts/count`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const readAudience = async ({
  audienceId,
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/audiences/${audienceId}`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readAudiences = async ({
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/audiences`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readFieldsSchemaFromSource = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  sourceId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/sources/${sourceId}`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readOperators = async ({
  data,
  domain,
  headers,
  query,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/audiences/builder/operators`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readSourceFieldsFromDepartment = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/source-fields`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readSourcesFromDepartment = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/sources`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const readSourcesFromLocation = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/sources`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const saveAudience = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/audiences`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const searchContactsFromLocation = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/contacts/search`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const searchFieldValues = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  schemaId,
  fieldName,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/contacts/schema/${schemaId}/field_values/${fieldName}`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const updateAudience = async ({
  audienceId,
  data,
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/audiences/${audienceId}`,
    headers,
    method: HTTPMethod.PUT,
    query,
    signal
  });
};
const createAudio = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/audio/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteAudio = async ({
  audioId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/audio/${audioId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readAudioByBoardId = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/audio/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.GET,
  query
});
const readAudioById = async ({
  audioId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/audio/${audioId}`,
  headers,
  method: HTTPMethod.GET,
  query
});
const createBoard = async ({
  data,
  headers,
  organizationId,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/boards/${organizationId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createNotificationRecipient = async ({
  boardId,
  email,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/notifications/${email}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createSuggestedResponse = async ({
  boardId,
  body,
  title,
  headers,
  domain,
  query
}) => fetchRequest({
  data: {
    body,
    title
  },
  domain,
  endpoint: `/suggestedresponses/board/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createVoicemail = async ({
  boardId,
  file,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { file },
  domain,
  endpoint: `/boards/${boardId}/voicemail`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const deactivateBoard = async ({
  headers,
  boardId,
  domain,
  query
}) => fetchRequest({
  data: { archived: true },
  domain,
  endpoint: `/boards/${boardId}/deactivate`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const deleteCallForwarding = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/forwardTo`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteNotificationRecipient = async ({
  boardId,
  email,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/notifications/${email}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteSuggestedResponse = async ({
  id,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/suggestedresponses/${id}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteVoicemail = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/voicemail`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const duplicateSuggestedResponses = async ({
  headers,
  data,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: "/suggestedresponses/duplicate",
  headers,
  method: HTTPMethod.POST,
  query
});
const readAdminBoards = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/list`,
  headers,
  query
});
const readBoard = async ({
  boardId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}`,
  headers,
  query,
  signal
});
const readBoardsByDepartment = async ({
  departmentId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/locations/${departmentId}/workspaces`,
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const readBoardsByOrganization = async ({
  organizationId,
  headers,
  archived = false,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/byOrganization/${organizationId}`,
  headers,
  query: {
    ...query,
    ...archived ? { includes: "archived" } : {}
  }
});
const readBoardsByUser = async ({
  userId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/byUser/${userId}`,
  headers,
  query
});
const readCallForwarding = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/forwardTo`,
  headers,
  query
});
const readNotificationRecipients = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/notifications`,
  headers,
  query
});
const readSnippets = async ({
  boardId,
  headers,
  domain,
  query
}) => {
  return fetchRequest({
    domain,
    endpoint: `/boards/${boardId}/snippets`,
    headers,
    query
  });
};
const readSuggestedResponsesByBoard = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/suggestedresponses/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.GET,
  query
});
const readUsersByBoard = async ({
  boardId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/boards/${boardId}/team`,
  headers,
  query,
  signal
});
const updateBoard = async ({
  boardId,
  headers,
  data: { email, ...restData },
  domain,
  query
}) => fetchRequest({
  data: {
    emailAlias: email,
    ...restData
  },
  domain,
  endpoint: `/boards/${boardId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardEmailAlias = async ({
  boardId,
  email,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { alias: email },
  domain,
  endpoint: `/boards/${boardId}/email-alias`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardFeatureFlags = async ({
  boardId,
  headers,
  data,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/boards/${boardId}/features`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardName = async ({
  boardId,
  name,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { name },
  domain,
  endpoint: `/boards/${boardId}/name`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardNickname = async ({
  boardId,
  nickname,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { nickname },
  domain,
  endpoint: `/boards/${boardId}/nickname`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardSettings = async ({
  boardId,
  headers,
  data: { ...restData },
  domain,
  query
}) => fetchRequest({
  data: {
    ...restData
  },
  domain,
  endpoint: `/board-settings/${boardId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateBoardTeamMembers = async ({
  boardId,
  data: { userId, ...restData },
  headers,
  domain,
  query
}) => fetchRequest({
  data: { userID: userId, ...restData },
  domain,
  endpoint: `/boards/${boardId}/team`,
  headers,
  method: HTTPMethod.POST,
  query
});
const updateBoardTimezone = async ({
  boardId,
  offsetHours,
  observesDaylightSavings,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { observesDaylightSavings, offsetHours },
  domain,
  endpoint: `/boards/${boardId}/timezone`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateCallForwarding = async ({
  boardId,
  forwardTo,
  forwardName,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { forwardName, forwardTo },
  domain,
  endpoint: `/boards/${boardId}/forwardTo`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateContactBoardAndColumn = async ({
  boardId,
  columnId,
  contactId,
  destinationBoardId,
  index,
  sourceBoardId,
  headers,
  domain,
  query
}) => fetchRequest({
  data: {
    columnID: columnId,
    contactID: contactId,
    destinationBoardID: destinationBoardId,
    index,
    sourceBoardID: sourceBoardId
  },
  domain,
  endpoint: `/boards/${boardId}/contact/transfer`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateNotificationRecipients = async ({
  boardId,
  userId,
  email,
  sms,
  headers,
  domain,
  query
}) => fetchRequest({
  data: {
    email,
    sms,
    userID: userId
  },
  domain,
  endpoint: `/boards/${boardId}/notifications`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateSuggestedResponse = async ({
  id,
  body,
  title,
  headers,
  boardId,
  domain,
  query
}) => fetchRequest({
  data: {
    boardID: boardId,
    body,
    title
  },
  domain,
  endpoint: `/suggestedresponses/${id}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createInboundCall = async ({
  callId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/calls/answer/${callId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createOutboundCall = async ({
  boardId,
  contactId = null,
  toNumber,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { boardID: boardId, contactID: contactId, toNumber },
  domain,
  endpoint: "/calls/outbound",
  headers,
  method: HTTPMethod.POST,
  query
});
const readTwilioToken = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: "/twilio/token",
  headers,
  query
});
const readTwilioTokenV1 = async ({
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: "/v1/twilio/token",
  headers,
  query,
  signal
});
const createCampaign = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteCampaign = async ({
  campaignId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/campaigns/${campaignId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const duplicateCampaign = async ({
  campaignId,
  boardIDs,
  campaignName,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { boardIDs, campaignName },
  domain,
  endpoint: `/v1/campaigns/${campaignId}/duplicate`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readCampaign = async ({
  campaignId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/campaigns/${campaignId}`,
  headers,
  query
});
const readCampaignLaunchPreview = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/preview/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readCampaignsByBoard = async ({
  boardId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/campaigns/byBoard/${boardId}`,
  headers,
  query
});
const readCampaignsByDepartment = async ({
  departmentId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/v2/departments/${departmentId}/campaigns`,
  headers,
  method: HTTPMethod.GET,
  query
});
const readContactsByCampaign = async ({
  campaignId,
  headers,
  domain,
  query
}) => {
  return fetchRequest({
    domain,
    endpoint: `/campaigns/${campaignId}/contacts`,
    headers,
    query
  });
};
const removeAllContactsFromCampaign = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/ejectAll/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const removeContactsFromCampaign = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/eject/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const updateCampaign = async ({
  campaignId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/${campaignId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateLaunchCampaign = async ({
  boardId,
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/campaigns/launch/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createColumn = async ({
  boardId,
  name,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { name },
  domain,
  endpoint: `/boards/${boardId}/column`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteColumn = async ({
  boardId,
  columnId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/boards/${boardId}/column/${columnId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const updateColumnIndex = async ({
  boardId,
  columnId,
  index,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { index },
  domain,
  endpoint: `/boards/${boardId}/column/${columnId}/move`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateColumnName = async ({
  boardId,
  columnId,
  name,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { name },
  domain,
  endpoint: `/boards/${boardId}/column/${columnId}/name`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateMoveContactToColumnAtIndex = async ({
  boardId,
  columnId,
  contactId,
  index,
  headers,
  domain,
  previousConversationId,
  previousContactId,
  conversationId,
  query
}) => fetchRequest({
  data: {
    columnID: columnId,
    contactID: contactId,
    conversationId,
    index,
    previousContactId,
    previousConversationId
  },
  domain,
  endpoint: `/boards/${boardId}/contact`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateMoveContactToTopOfColumn = async ({
  boardId,
  contactId,
  columnId,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { contactID: contactId },
  domain,
  endpoint: `/boards/${boardId}/contact/toTop/${columnId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createScheduledMessage = async ({
  query,
  boardId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/scheduled/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createSendEmail = async ({
  query,
  boardId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/emails/outbound/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createSendSMS = async ({
  query,
  boardId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/sms/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteScheduledMessage = async ({
  query,
  communicationId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/scheduled/${communicationId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readCommunicationsByContactId = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/communications/${contactId}`,
  headers,
  query
});
const readConversation = async ({
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: "/v2/messaging/conversation",
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const updateScheduledMessage = async ({
  query,
  communicationId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/scheduled/${communicationId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateSetAsRead = async ({
  query,
  boardId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/communications/read/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateSetContactAsUnread = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/unread/${contactId}/increment`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const archiveContactsByBoard = async ({
  boardId,
  columnID,
  contactIDs,
  headers,
  domain,
  query
}) => fetchRequest({
  data: { columnID, contactIDs },
  domain,
  endpoint: `/contacts/archive/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const countContactsByBoard = async ({
  data,
  domain,
  headers,
  query,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/contacts/count`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const createContact = async ({
  query,
  boardId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/opportunities/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createSavedSearch = async ({
  query,
  boardId,
  domain,
  headers,
  data
}) => fetchRequest({
  data,
  domain,
  endpoint: `/savedSearch/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteContact = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/contacts/${contactId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteSavedSearch = async ({
  id,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/savedSearch/${id}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const editSavedSearch = async ({
  query,
  domain,
  headers,
  id,
  savedSearch
}) => fetchRequest({
  data: savedSearch,
  domain,
  endpoint: `/savedSearch/${id}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const insertCSV = async ({
  query,
  boardId,
  domain,
  fields,
  fileKey,
  headers
}) => fetchRequest({
  data: {
    fields,
    fileKey
  },
  domain,
  endpoint: `/csv/insert/${boardId}`,
  headers: {
    ...headers,
    "csv-date-format": true,
    "v2-parse": true
  },
  method: HTTPMethod.POST,
  query
});
const optOutContact = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/contacts/optOut/${contactId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const parseCSV = async ({
  query,
  boardId,
  body,
  domain,
  headers
}) => fetchRequest({
  data: body,
  domain,
  endpoint: `/csv/parse/${boardId}`,
  headers: {
    ...headers,
    "content-type": "application/octet-stream",
    "csv-date-format": true,
    "v2-parse": true
  },
  method: HTTPMethod.POST,
  query
});
const readAllSavedSearchesByBoard = async ({
  query,
  boardId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/savedSearch/byBoard/${boardId}`,
  headers,
  query
});
const readContact = async ({
  contactId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/contacts/${contactId}`,
  headers,
  query
});
const readContactIDsByBoard = async ({
  data,
  domain,
  headers,
  query
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/contacts`,
    headers,
    method: HTTPMethod.GET,
    query
  });
};
const readContactIDsByBoardByQuery = async ({
  query,
  boardId,
  data,
  domain,
  headers
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/contacts/byBoard/${boardId}/IDs/advanced`,
    headers: {
      ...headers,
      "Content-Type": "text/plain"
    },
    method: HTTPMethod.POST,
    query
  });
};
const readContactsByBoard = async ({
  query,
  boardId,
  contactIDs,
  domain,
  headers
}) => fetchRequest({
  data: { contactIDs },
  domain,
  endpoint: `/contacts/byBoard/${boardId}/list`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readContactsByOrganization = async ({
  query,
  contactIDs,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data: { contactIDs },
  domain,
  endpoint: `/contacts/byOrganization/${organizationId}/list`,
  headers,
  method: HTTPMethod.POST,
  query
});
const searchContacts = async ({
  query,
  departmentId,
  domain,
  headers,
  ...data
}) => fetchRequest({
  data: { ...data },
  domain,
  endpoint: `/v1/contacts/${departmentId}/search`,
  headers,
  method: HTTPMethod.POST,
  query
});
const updateContact = async ({
  query,
  contact,
  contactId,
  domain,
  headers
}) => fetchRequest({
  data: { ...contact },
  domain,
  endpoint: `/contacts/${contactId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createCustomSource = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/custom_sources`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const deleteCustomSource = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  customSourceId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/custom_sources/${customSourceId}`,
    headers,
    method: HTTPMethod.DELETE,
    query,
    signal
  });
};
const readCustomSources = async ({
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/custom_sources`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const createDepartment = async ({
  query,
  data: { name },
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data: { name },
  domain,
  endpoint: `/departments/${organizationId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createDepartmentSourceField = async ({
  query,
  departmentId,
  domain,
  headers,
  sourceField
}) => fetchRequest({
  data: sourceField,
  domain,
  endpoint: `/sources/${departmentId}/fields`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readDepartmentsByOrganization = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/departments/byOrganization/${organizationId}`,
  headers,
  query
});
const readDepartmentSourceFieldsById = async ({
  query,
  departmentId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/departments/${departmentId}/sources/fields`,
    headers,
    query
  });
};
const readDepartmentSourceFieldsByValue = async ({
  query,
  departmentId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v1/audiences/${departmentId}/search-fields`,
    headers,
    query
  });
};
const readDepartmentSourceFieldsElastic = async ({
  query,
  departmentId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v1/departments/${departmentId}/fields`,
    headers,
    query
  });
};
const syncDepartmentSourceFields = async ({
  data,
  query,
  domain,
  headers
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v1/audiences/syncs`,
    headers,
    method: HTTPMethod.POST,
    query
  });
};
const updateDepartmentSourceField = async ({
  data,
  query,
  domain,
  headers,
  departmentId
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/sources/${departmentId}/fields`,
    headers,
    method: HTTPMethod.PUT,
    query
  });
};
const updateDepartmentSourceFieldById = async ({
  query,
  domain,
  headers,
  id,
  sourceField
}) => fetchRequest({
  data: sourceField,
  domain,
  endpoint: `/sources/${id}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createGroup = async ({
  query,
  boardId,
  data: { name, query: HQLQuery, builderQuery },
  domain,
  headers
}) => fetchRequest({
  data: {
    builderQuery: sanitizeBuilderQuery(builderQuery),
    name,
    query: HQLQuery
  },
  domain,
  endpoint: `/groups/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createLaunchGroup = async ({
  query,
  data: { campaignId, sendSize },
  domain,
  groupId,
  headers
}) => fetchRequest({
  data: { campaignID: campaignId, sendSize },
  domain,
  endpoint: `/groups/${groupId}/launch`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteGroup = async ({
  id,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/groups/${id}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readGroupBuilderPreview = async ({
  query,
  boardId,
  data: { builderQuery, ...restData },
  domain,
  headers,
  limit,
  offset
}) => fetchRequest({
  data: { builderQuery: sanitizeBuilderQuery(builderQuery), ...restData },
  domain,
  endpoint: `/query/${boardId}/builder`,
  headers,
  method: HTTPMethod.POST,
  query: {
    ...query,
    limit,
    offset
  }
});
const readGroupsByBoard = async ({
  query,
  boardId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/groups/byBoard/${boardId}`,
  headers,
  method: HTTPMethod.GET,
  query
});
const updateGroup = async ({
  query,
  domain,
  headers,
  data: { description, builderQuery, id, locked, name, query: HQLQuery }
}) => fetchRequest({
  data: {
    builderQuery: sanitizeBuilderQuery(builderQuery),
    description,
    locked,
    name,
    query: HQLQuery
  },
  domain,
  endpoint: `/groups/${id}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const readQueryByBoardId = async ({
  query,
  boardId,
  data,
  domain,
  headers
}) => fetchRequest({
  data,
  domain,
  endpoint: `/query/${boardId}`,
  headers: {
    ...headers,
    "Content-Type": "text/plain"
  },
  method: HTTPMethod.POST,
  query
});
const readApiKey = async ({
  headers,
  userId,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/apikeys/${userId}`,
  headers,
  query
});
const authorizeIntegration = async ({
  data,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: "/v2/integrations/oauth2/callback",
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
const configureIntegration = async ({
  data,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: "/v2/integrations/oauth2/configure",
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const createSetupTrackerFollowUpEmail = async ({
  query,
  departmentId,
  setupTrackerId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/setup_trackers/${setupTrackerId}/follow_up_email`,
    headers,
    method: HTTPMethod.POST,
    query
  });
};
const getDepartments = async ({
  query,
  domain,
  headers,
  signal
}) => fetchRequest({
  domain,
  endpoint: "/v2/integrations/oauth2/departments",
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const getIntegrationBySlug = async ({
  query,
  integrationSlug,
  domain,
  headers,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/integrations/oauth2/integration/${integrationSlug}`,
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const getOrCreateSetupTracker = async ({
  query,
  departmentId,
  instanceId,
  domain,
  headers
}) => fetchRequest({
  data: {
    department_id: departmentId,
    instance_id: instanceId
  },
  domain,
  endpoint: `/v2/setup_trackers`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readIntegrationsByOrganization = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/integrations/byOrganization/${organizationId}`,
  headers,
  query
});
const syncIntegrationById = async ({
  query,
  departmentId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/integrations/byDepartment/${departmentId}/syncSinceLast`,
  headers,
  method: HTTPMethod.POST,
  query
});
const updateSetupTracker = async ({
  query,
  departmentId,
  setupTrackerId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/setup_trackers/${setupTrackerId}`,
    headers,
    method: HTTPMethod.PATCH,
    query
  });
};
const authenticatePrismaticCustomer = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/prismatic_customer_authentications`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const createPrismaticInstance = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/prismatic_instances`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal
  });
};
const getMarketplaceIntegration = async ({
  domain,
  headers,
  departmentId,
  integrationId,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/marketplace_integrations/${integrationId}`,
    headers,
    method: HTTPMethod.GET,
    signal
  });
};
const readMarketplaceIntegrations = async ({
  domain,
  headers,
  departmentId,
  query,
  signal
}) => {
  return fetchRequest({
    domain,
    endpoint: `/v2/departments/${departmentId}/marketplace_integrations`,
    headers,
    method: HTTPMethod.GET,
    query,
    signal
  });
};
const reloadPrismaticInstanceStatus = async ({
  data,
  domain,
  headers,
  query,
  departmentId,
  prismaticInstanceRef,
  signal
}) => {
  return fetchRequest({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/prismatic_instances/${prismaticInstanceRef}/reload_status`,
    headers,
    method: HTTPMethod.PUT,
    query,
    signal
  });
};
const createNote = async ({
  query,
  body,
  contactId,
  domain,
  headers
}) => fetchRequest({
  data: { body },
  domain,
  endpoint: `/notes/${contactId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createNoteV2 = async ({
  query,
  contactId,
  content,
  mongoId,
  domain,
  headers,
  workspaceId,
  signal
}) => fetchRequest({
  data: {
    contact_id: contactId,
    content,
    mongo_id: mongoId,
    workspace_id: workspaceId
  },
  domain,
  endpoint: "/v2/messaging/notes",
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const deleteNote = async ({
  noteId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/notes/${noteId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteNoteV2 = async ({
  noteId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/notes/${noteId}`,
  headers,
  method: HTTPMethod.DELETE,
  query,
  signal
});
const readNotesByContact = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/notes/byContact/${contactId}`,
  headers,
  query
});
const readNotesByContactV2 = async ({
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/notes`,
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const updateNote = async ({
  query,
  body,
  domain,
  headers,
  noteId
}) => fetchRequest({
  data: { body },
  domain,
  endpoint: `/notes/${noteId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateNoteV2 = async ({
  query,
  content,
  domain,
  headers,
  noteId,
  signal
}) => fetchRequest({
  data: { content },
  domain,
  endpoint: `/v2/messaging/notes/${noteId}`,
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
const readNotificationSettingsByUser = async ({
  query,
  domain,
  headers,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/notifications/byUser/${userId}`,
  headers,
  query
});
const updateAllNotificationSettingsByUser = async ({
  query,
  domain,
  headers,
  userId,
  ...payload
}) => fetchRequest({
  data: {
    ...payload
  },
  domain,
  endpoint: `/notifications/byUser/${userId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createAccount = async ({
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/hatch-elixir/onboarding/account-create`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readOpportunitiesByContact = async ({
  contactId,
  domain,
  headers,
  query
}) => fetchRequest({
  domain,
  endpoint: `/opportunities/byContact/${contactId}`,
  headers,
  query
});
const createOrganization = async ({
  query,
  data: { salesforceId, ...restData },
  domain,
  headers
}) => fetchRequest({
  data: {
    salesforceID: salesforceId,
    ...restData
  },
  domain,
  endpoint: "/organizations",
  headers,
  method: HTTPMethod.POST,
  query
});
const createOrganizationToken = async ({
  query,
  data,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data,
  domain,
  endpoint: `/organizations/${organizationId}/tokens`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createOrganizationUserInvite = async ({
  query,
  data,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data,
  domain,
  endpoint: `/organizations/${organizationId}/invite`,
  headers,
  method: HTTPMethod.POST,
  query
});
const deactivateOrganizationTeamMember = async ({
  query,
  domain,
  headers,
  organizationId,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/user/${userId}/deactivate`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const deleteOrganizationToken = async ({
  query,
  domain,
  headers,
  organizationId,
  tokenId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/tokens/${tokenId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readOrganization = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}`,
  headers,
  query
});
const readOrganizationIDsByUser = async ({
  query,
  domain,
  headers,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/byUser/${userId}`,
  headers,
  query
});
const readOrganizations = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: "/organizations/list",
  headers,
  query
});
const readOrganizationsByUser = async ({
  query,
  domain,
  headers,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/byUser/${userId}/list`,
  headers,
  query
});
const readOrganizationTeam = async ({
  query,
  disabled = false,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/team`,
  headers,
  query: {
    ...query,
    disabled
  }
});
const readOrganizationTokens = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/tokens`,
  headers,
  method: HTTPMethod.GET,
  query
});
const readOrganizationTwilioRegistrations = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/v2/organization/${organizationId}/messaging/settings/twilio_registrations`,
  headers,
  method: HTTPMethod.GET,
  query
});
const readOrganizationUsersByOrganization = async ({
  query,
  domain,
  headers,
  organizationId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/users`,
  headers,
  query
});
const removeOrganizationTeamMembers = async ({
  query,
  domain,
  headers,
  organizationId,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/users/${userId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const updateOrganization = async ({
  query,
  data: { salesforceId, ...restData },
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data: {
    salesforceID: salesforceId,
    ...restData
  },
  domain,
  endpoint: `/organizations/${organizationId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateOrganizationSalesforceId = async ({
  query,
  data: { salesforceId },
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data: { salesforceID: salesforceId },
  domain,
  endpoint: `/organizations/${organizationId}/salesforceID`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateOrganizationTeamMembers = async ({
  query,
  data: { userId, ...restData },
  domain,
  headers,
  organizationId
}) => fetchRequest({
  data: { userID: userId, ...restData },
  domain,
  endpoint: `/organizations/${organizationId}/users`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createForgotPasswordCode = async ({
  data,
  domain,
  headers,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: `/password/forgot`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createResetPasswordSession = async ({
  query,
  data,
  domain,
  headers
}) => fetchRequest({
  data,
  domain,
  endpoint: `/password/reset`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createSessionFromToken = async ({
  token,
  domain,
  headers,
  query
}) => fetchRequest({
  data: { token },
  domain,
  endpoint: `/password/forgot`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createReminder = async ({
  query,
  boardId,
  contactId,
  domain,
  headers,
  notes,
  remindAt
}) => fetchRequest({
  data: { contactID: contactId, notes, remindAt },
  domain,
  endpoint: `/reminders/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createReminderV2 = async ({
  query,
  conversationId,
  contactId,
  domain,
  headers,
  notes,
  remindAt,
  userId,
  signal
}) => fetchRequest({
  data: {
    contact_id: contactId,
    notes,
    remind_at: remindAt,
    user_id: userId
  },
  domain,
  endpoint: `/v2/messaging/conversation/${conversationId}/reminder`,
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const deleteReminder = async ({
  query,
  domain,
  headers,
  reminderId
}) => fetchRequest({
  domain,
  endpoint: `/reminders/${reminderId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteReminderV2 = async ({
  query,
  domain,
  headers,
  conversationId,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/conversation/${conversationId}/reminder`,
  headers,
  method: HTTPMethod.DELETE,
  query,
  signal
});
const readReminderByContactId = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/reminders/byContact/${contactId}`,
  headers,
  query
});
const readRemindersByBoardId = async ({
  query,
  boardId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/reminders/byBoard/${boardId}`,
  headers,
  query
});
const updateReminder = async ({
  query,
  domain,
  headers,
  notes,
  remindAt,
  reminderId
}) => fetchRequest({
  data: { notes, remindAt },
  domain,
  endpoint: `/reminders/${reminderId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateReminderV2 = async ({
  query,
  conversationId,
  contactId,
  domain,
  headers,
  id,
  notes,
  remindAt,
  userId,
  signal
}) => fetchRequest({
  data: {
    contact_id: contactId,
    id,
    notes,
    remind_at: remindAt,
    user_id: userId
  },
  domain,
  endpoint: `/v2/messaging/conversation/${conversationId}/reminder`,
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
const readReportCampaignResponsesByCampaignId = async ({
  query,
  campaignId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/reporting/campaign/${campaignId}/responses`,
    headers,
    query
  });
};
const readReportWidgetsByUser = async ({
  query,
  boardIDs,
  campaignIDs = [],
  domain,
  end,
  headers,
  sectionDurationInHours,
  start,
  userId,
  widgets
}) => fetchRequest({
  data: {
    boardIDs,
    campaignIDs,
    end,
    sectionDurationInHours,
    start,
    widgets
  },
  domain,
  endpoint: `/reporting/byUser/${userId}/widget`,
  headers,
  method: HTTPMethod.POST,
  query
});
const readSearchSalesboard = async ({
  query,
  boardId,
  domain,
  headers
}) => {
  return fetchRequest({
    domain,
    endpoint: `/boards/${boardId}`,
    headers,
    query
  });
};
const createSession = async ({
  data,
  headers,
  domain,
  query
}) => fetchRequest({
  data,
  domain,
  endpoint: "/login",
  headers,
  method: HTTPMethod.POST,
  query
});
const deleteSession = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: "/logout",
  headers,
  method: HTTPMethod.POST,
  query
});
const createSoldHistory = async ({
  amountInCents,
  query,
  boardId,
  contactId: contactID,
  domain,
  headers,
  notes,
  soldAt
}) => fetchRequest({
  data: { amountInCents, contactID, notes, soldAt },
  domain,
  endpoint: `/soldHistory/${boardId}`,
  headers,
  method: HTTPMethod.POST,
  query
});
const createSoldHistoryV2 = async ({
  boardId,
  userId,
  contactId,
  mongoId,
  note,
  amountInCents,
  soldAt,
  query,
  domain,
  headers,
  signal,
  workspaceId
}) => fetchRequest({
  data: {
    amount_in_cents: amountInCents,
    board_id: boardId,
    contact_id: contactId,
    mongo_id: mongoId,
    note,
    sold_at: soldAt,
    user_id: userId,
    workspace_id: workspaceId
  },
  domain,
  endpoint: `/v2/messaging/contact/${contactId}/sold_histories`,
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const deleteSoldHistory = async ({
  query,
  domain,
  headers,
  soldHistoryId
}) => fetchRequest({
  domain,
  endpoint: `/soldHistory/${soldHistoryId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const deleteSoldHistoryV2 = async ({
  contactId,
  query,
  domain,
  headers,
  signal,
  soldHistoryId
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/contact/${contactId}/sold_histories/${soldHistoryId}`,
  headers,
  method: HTTPMethod.DELETE,
  query,
  signal
});
const readSoldHistoryByBoard = async ({
  query,
  boardId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/soldHistory/byBoard/${boardId}`,
  headers,
  query
});
const readSoldHistoryByContact = async ({
  query,
  contactId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/soldHistory/byContact/${contactId}`,
  headers,
  query
});
const readSoldHistoryByContactV2 = async ({
  contactId,
  query,
  domain,
  headers,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/contact/${contactId}/sold_histories`,
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const updateSoldHistory = async ({
  amountInCents,
  query,
  contactId,
  domain,
  headers,
  notes,
  soldAt,
  soldHistoryId
}) => fetchRequest({
  data: { amountInCents, contactId, id: soldHistoryId, notes, soldAt },
  domain,
  endpoint: `/soldHistory/${soldHistoryId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateSoldHistoryV2 = async ({
  contactId,
  note,
  amountInCents,
  soldAt,
  query,
  domain,
  headers,
  signal,
  soldHistoryId
}) => fetchRequest({
  data: {
    amount_in_cents: amountInCents,
    note,
    sold_at: soldAt
  },
  domain,
  endpoint: `/v2/messaging/contact/${contactId}/sold_histories/${soldHistoryId}`,
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
const deactivateTeamMember = async ({
  query,
  domain,
  headers,
  organizationId,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/organizations/${organizationId}/user/${userId}/deactivate`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateTeamMember = async ({
  query,
  assignedBoardIDs,
  domain,
  headers,
  organizationId,
  role,
  userId
}) => fetchRequest({
  data: { assignedBoardIDs, role, userID: userId },
  domain,
  endpoint: `/organizations/${organizationId}/users`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createTouch = async ({
  action,
  query,
  boardId,
  campaignID,
  component,
  contactID,
  domain,
  headers,
  userId
}) => fetchRequest({
  data: { action, campaignID, component, contactID },
  domain,
  endpoint: `/touches/${boardId}/byUser/${userId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const deleteTouch = async ({
  query,
  boardId,
  domain,
  headers,
  userId
}) => fetchRequest({
  domain,
  endpoint: `/touches/${boardId}/byUser/${userId}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readTouchesByBoard = async ({
  query,
  boardId,
  domain,
  headers
}) => fetchRequest({
  domain,
  endpoint: `/touches/${boardId}/all`,
  headers,
  query
});
const createUser = async ({
  query,
  data,
  domain,
  headers
}) => fetchRequest({
  data,
  domain,
  endpoint: "/user",
  headers,
  method: HTTPMethod.POST,
  query
});
const readAllUsersProfiles = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/profiles/list`,
  headers,
  query
});
const readUser = async ({
  userId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/user/${userId}`,
  headers,
  query
});
const readUserId = async ({
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/user`,
  headers,
  query
});
const readUserProfile = async ({
  userId,
  headers,
  domain,
  query
}) => fetchRequest({
  domain,
  endpoint: `/profiles/${userId}`,
  headers,
  query
});
const updateUserBoardOrder = async ({
  query,
  domain,
  headers,
  boardOrder,
  userId
}) => fetchRequest({
  data: { boardOrder },
  domain,
  endpoint: `/user/${userId}`,
  headers,
  method: HTTPMethod.PATCH,
  query
});
const updateUserEmail = async ({
  query,
  domain,
  email,
  headers,
  userId
}) => fetchRequest({
  data: { email, userId },
  domain,
  endpoint: `/user/email/${userId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateUserPassword = async ({
  query,
  domain,
  headers,
  password,
  userId
}) => fetchRequest({
  data: { password, userId },
  domain,
  endpoint: `/user/password/${userId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const updateUserProfile = async ({
  query,
  apps,
  domain,
  firstName,
  headers,
  icon,
  lastName,
  phoneNumber,
  userId
}) => fetchRequest({
  data: { apps, firstName, icon, lastName, phoneNumber },
  domain,
  endpoint: `/profiles/${userId}`,
  headers,
  method: HTTPMethod.PUT,
  query
});
const createWorkflow = async ({
  data,
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: `/v2/locations/${locationId}/boards/${boardId}/workflows`,
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const deleteWorkflow = async ({
  query,
  data,
  domain,
  headers,
  id
}) => fetchRequest({
  data,
  domain,
  endpoint: `/workflows/${id}`,
  headers,
  method: HTTPMethod.DELETE,
  query
});
const readWorkflowContacts = async ({
  query,
  domain,
  headers,
  id,
  type
}) => {
  return fetchRequest({
    domain,
    endpoint: `/workflows/${id}/contacts/${type}`,
    headers,
    query
  });
};
const readWorkflows = async ({
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/locations/${locationId}/boards/${boardId}/workflows`,
  headers,
  method: HTTPMethod.GET,
  query,
  signal
});
const updateWorkflow = async ({
  query,
  data,
  domain,
  headers,
  id,
  boardId,
  locationId,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: `/v2/locations/${locationId}/boards/${boardId}/workflows/${id}`,
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
const createWorkspace = async ({
  data,
  headers,
  organizationId,
  domain,
  query,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: `/v2/messaging/organization/${organizationId}/workspaces/`,
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const deactivateWorkspace = async ({
  headers,
  workspaceId,
  domain,
  query,
  signal
}) => fetchRequest({
  data: { archived: true },
  domain,
  endpoint: `/v2/messaging/workspaces/${workspaceId}/deactivate`,
  headers,
  method: HTTPMethod.POST,
  query,
  signal
});
const readAllWorkspaces = async ({
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/workspaces/`,
  headers,
  query,
  signal
});
const readWorkspace = async ({
  workspaceId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/workspaces/${workspaceId}`,
  headers,
  query,
  signal
});
const readWorkspacesByOrganization = async ({
  organizationId,
  headers,
  archived = false,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/organization/${organizationId}/workspaces`,
  headers,
  query: {
    ...query,
    ...archived ? { includes_inactive: true } : {}
  },
  signal
});
const readWorkspacesColumnsByOrganization = async ({
  organizationId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/organization/${organizationId}/workspaces/columns`,
  headers,
  query,
  signal
});
const readWorkspacesSettingsByOrganization = async ({
  organizationId,
  headers,
  domain,
  query,
  signal
}) => fetchRequest({
  domain,
  endpoint: `/v2/messaging/organization/${organizationId}/workspaces/settings`,
  headers,
  query,
  signal
});
const updateWorkspace = async ({
  workspaceId,
  headers,
  data,
  domain,
  query,
  signal
}) => fetchRequest({
  data,
  domain,
  endpoint: `/v2/messaging/workspaces/${workspaceId}`,
  headers,
  method: HTTPMethod.PUT,
  query,
  signal
});
export { addToLookupTable, archiveContactsByBoard, arrayInsertAtIndex, authenticatePrismaticCustomer, authorizeIntegration, boardIdFromColumnId, booleanOperationList, buildHQLQueryFromFilters, buildHQLQueryFromString, buildSimpleSearchQuery, calculateCurrentPage, calculateTotalPages, campaignOperationList, configureIntegration, countContactsByBoard, createAPIKey, createAccount, createAudio, createBinaryExpression, createBoard, createCampaign, createColumn, createConstantValue, createContact, createCustomSource, createDepartment, createDepartmentSourceField, createForgotPasswordCode, createGroup, createInboundCall, createLaunchGroup, createNote, createNoteV2, createNotificationRecipient, createNullExpression, createOrganization, createOrganizationToken, createOrganizationUserInvite, createOutboundCall, createPrismaticInstance, createReferenceValue, createRelativeDateValue, createReminder, createReminderV2, createResetPasswordSession, createSavedSearch, createScheduledMessage, createSendEmail, createSendSMS, createSession, createSessionFromToken, createSetupTrackerFollowUpEmail, createSoldHistory, createSoldHistoryV2, createSuggestedResponse, createTouch, createUnaryExpression, createUser, createVariadicExpression, createVoicemail, createWorkflow, createWorkspace, dateOperationList, deactivateBoard, deactivateOrganizationTeamMember, deactivateTeamMember, deactivateWorkspace, deleteAudience, deleteAudio, deleteCallForwarding, deleteCampaign, deleteColumn, deleteContact, deleteCustomSource, deleteGroup, deleteNote, deleteNoteV2, deleteNotificationRecipient, deleteOrganizationToken, deleteReminder, deleteReminderV2, deleteSavedSearch, deleteScheduledMessage, deleteSession, deleteSoldHistory, deleteSoldHistoryV2, deleteSuggestedResponse, deleteTouch, deleteVoicemail, deleteWorkflow, duplicateCampaign, duplicateSuggestedResponses, editSavedSearch, fetchRequest, fileNameFromURL, formatCustomerName, formatFileSize, formatPercentage, formatPhoneNumber, generateColor, generateQueryParams, getContactsTotalCount, getDepartments, getFileExtension, getIntegrationBySlug, getMarketplaceIntegration, getOperatorDefinitionByOperator, getOrCreateSetupTracker, injectTermIntoSimpleSearch, insertCSV, mapOperator, numberOperationList, operatorDefinitions, operatorDefinitionsByType, operatorDefinitionsList, optOutContact, parseBuilderQuery, parseCSV, readAPIKeys, readAdminBoards, readAllSavedSearchesByBoard, readAllUsersProfiles, readAllWorkspaces, readApiKey, readAudience, readAudiences, readAudioByBoardId, readAudioById, readBoard, readBoardsByDepartment, readBoardsByOrganization, readBoardsByUser, readCallForwarding, readCampaign, readCampaignLaunchPreview, readCampaignsByBoard, readCampaignsByDepartment, readCommunicationsByContactId, readContact, readContactIDsByBoard, readContactIDsByBoardByQuery, readContactsByBoard, readContactsByCampaign, readContactsByOrganization, readConversation, readCustomSources, readDepartmentSourceFieldsById, readDepartmentSourceFieldsByValue, readDepartmentSourceFieldsElastic, readDepartmentsByOrganization, readFieldsSchemaFromSource, readGroupBuilderPreview, readGroupsByBoard, readIntegrationsByOrganization, readMarketplaceIntegrations, readNotesByContact, readNotesByContactV2, readNotificationRecipients, readNotificationSettingsByUser, readOperators, readOpportunitiesByContact, readOrganization, readOrganizationIDsByUser, readOrganizationTeam, readOrganizationTokens, readOrganizationTwilioRegistrations, readOrganizationUsersByOrganization, readOrganizations, readOrganizationsByUser, readQueryByBoardId, readReminderByContactId, readRemindersByBoardId, readReportCampaignResponsesByCampaignId, readReportWidgetsByUser, readSearchSalesboard, readSnippets, readSoldHistoryByBoard, readSoldHistoryByContact, readSoldHistoryByContactV2, readSourceFieldsFromDepartment, readSourcesFromDepartment, readSourcesFromLocation, readSuggestedResponsesByBoard, readTouchesByBoard, readTwilioToken, readTwilioTokenV1, readUser, readUserId, readUserProfile, readUsersByBoard, readWorkflowContacts, readWorkflows, readWorkspace, readWorkspacesByOrganization, readWorkspacesColumnsByOrganization, readWorkspacesSettingsByOrganization, relativeDateDirections, relativeDateOperationList, relativeDatePeriods, reloadPrismaticInstanceStatus, removeAllContactsFromCampaign, removeContactsFromCampaign, removeFromLookupTable, removeOrganizationTeamMembers, revokeAPIKey, sanitizeBuilderQuery, saveAudience, searchContacts, searchContactsFromLocation, searchFieldValues, stringOperationList, syncDepartmentSourceFields, syncIntegrationById, updateAllNotificationSettingsByUser, updateAudience, updateBoard, updateBoardEmailAlias, updateBoardFeatureFlags, updateBoardName, updateBoardNickname, updateBoardSettings, updateBoardTeamMembers, updateBoardTimezone, updateCallForwarding, updateCampaign, updateColumnIndex, updateColumnName, updateContact, updateContactBoardAndColumn, updateDepartmentSourceField, updateDepartmentSourceFieldById, updateGroup, updateLaunchCampaign, updateMoveContactToColumnAtIndex, updateMoveContactToTopOfColumn, updateNote, updateNoteV2, updateNotificationRecipients, updateOrganization, updateOrganizationSalesforceId, updateOrganizationTeamMembers, updateReminder, updateReminderV2, updateScheduledMessage, updateSetAsRead, updateSetContactAsUnread, updateSetupTracker, updateSoldHistory, updateSoldHistoryV2, updateSuggestedResponse, updateTeamMember, updateUserBoardOrder, updateUserEmail, updateUserPassword, updateUserProfile, updateWorkflow, updateWorkspace, validateEmail };
//# sourceMappingURL=index.js.map
